<template>
  <section class="s-shop-select__item" id="address" :data-step-content="[showOffer ? '02' : '04']">
    <div class="s-shop-options">
      <div class="s-kicker">{{ translations.slang_address_kicker }}</div>
      <div class="s-heading s-heading--3">
        <span class="s-heading__text">{{ translations.slang_address_headline }}</span>
      </div>
      <form class="s-form">

        <div class="s-form-item" ref="email" data-validated="">
          <label for="email" class="s-form-item__label">{{ translations.slang_address_mail }}</label>
          <input type="email" :value="email" class="s-form-item__field" name="email" @input="updateValue"/>
          <span v-if="email === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_mail_valid_1 }}</span>
          <span v-if="emailValid === false && email !== '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_mail_valid_2 }}</span>
        </div>

        <div class="s-form-item">
          <label for="name" class="s-form-item__label">{{ translations.slang_address_name }}</label>
          <input type="text" :value="name" class="s-form-item__field" name="name" @input="updateValue"/>
          <span v-if="name === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_name_valid }}</span>
        </div>

        <div class="s-form-item">
          <label for="club" class="s-form-item__label">{{ translations.slang_address_verein }}</label>
          <input type="text" :value="club" class="s-form-item__field" name="club" @input="updateValue"/>
          <span v-if="club === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_verein_valid }}</span>
        </div>

        <div class="s-form-item">
          <label for="street" class="s-form-item__label">{{ translations.slang_address_street }}</label>
          <input type="text" :value="street" class="s-form-item__field" name="street" @input="updateValue"/>
          <span v-if="street === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_street_valid }}</span>
        </div>

        <div class="s-form-item s-form-item--half-left">
          <label for="zip" class="s-form-item__label">{{ translations.slang_address_plz }}</label>
          <input type="text" :value="zip" class="s-form-item__field" name="zip" @input="updateValue"/>
          <span v-if="zip === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_plz_valid }}</span>
        </div>

        <div class="s-form-item s-form-item--half-right">
          <label for="city" class="s-form-item__label">{{ translations.slang_address_city }}</label>
          <input type="text" :value="city" class="s-form-item__field" name="city" @input="updateValue"/>
          <span v-if="city === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_city_valid }}</span>
        </div>

        <div class="s-form-item">
          <label for="country" class="s-form-item__label">{{ translations.slang_address_country }}</label>
          <div class="s-form-item__select">
            <select name="country" class="s-form-item__field s-form-item__field--select" @change="updateValue">
              <option value="BE" v-if="language === 'de'">Belgien</option>
              <option value="BG" v-if="language === 'de'">Bulgarien</option>
              <option value="DK" v-if="language === 'de'">Dänemark</option>
              <option value="DE" v-if="language === 'de'" selected>Deutschland</option>
              <option value="EE" v-if="language === 'de'">Estland</option>
              <option value="FI" v-if="language === 'de'">Finnland</option>
              <option value="FR" v-if="language === 'de'">Frankreich</option>
              <option value="GR" v-if="language === 'de'">Griechenland</option>
              <option value="IE" v-if="language === 'de'">Irland</option>
              <option value="IT" v-if="language === 'de'">Italien</option>
              <option value="HR" v-if="language === 'de'">Kroatien</option>
              <option value="LV" v-if="language === 'de'">Lettland</option>
              <option value="LT" v-if="language === 'de'">Litauen</option>
              <option value="MT" v-if="language === 'de'">Malta</option>
              <option value="NL" v-if="language === 'de'">Niederlande</option>
              <option value="PL" v-if="language === 'de'">Polen</option>
              <option value="PT" v-if="language === 'de'">Portugal</option>
              <option value="RO" v-if="language === 'de'">Rumänien</option>
              <option value="SE" v-if="language === 'de'">Schweden</option>
              <option value="SK" v-if="language === 'de'">Slowakei</option>
              <option value="SI" v-if="language === 'de'">Slowenien</option>
              <option value="ES" v-if="language === 'de'">Spanien</option>
              <option value="CZ" v-if="language === 'de'">Tschechien</option>
              <option value="HU" v-if="language === 'de'">Ungarn</option>

              <option value="BE" v-if="language === 'en'">Belgium</option>
              <option value="BG" v-if="language === 'en'">Bulgaria</option>
              <option value="DK" v-if="language === 'en'">Denmark</option>
              <option value="DE" v-if="language === 'en'" selected>Germany</option>
              <option value="EE" v-if="language === 'en'">Estonia</option>
              <option value="FI" v-if="language === 'en'">Finland</option>
              <option value="FR" v-if="language === 'en'">France</option>
              <option value="GR" v-if="language === 'en'">Greece</option>
              <option value="IE" v-if="language === 'en'">Ireland</option>
              <option value="IT" v-if="language === 'en'">Italy</option>
              <option value="HR" v-if="language === 'en'">Croatia</option>
              <option value="LV" v-if="language === 'en'">Latvia</option>
              <option value="LT" v-if="language === 'en'">Lithuania</option>
              <option value="MT" v-if="language === 'en'">Malta</option>
              <option value="NL" v-if="language === 'en'">Netherlands</option>
              <option value="PL" v-if="language === 'en'">Poland</option>
              <option value="PT" v-if="language === 'en'">Portugal</option>
              <option value="RO" v-if="language === 'en'">Romania</option>
              <option value="SE" v-if="language === 'en'">Sweden</option>
              <option value="SK" v-if="language === 'en'">Slovakia</option>
              <option value="SI" v-if="language === 'en'">Slovenia</option>
              <option value="ES" v-if="language === 'en'">Spain</option>
              <option value="CZ" v-if="language === 'en'">Czech Republic</option>
              <option value="HU" v-if="language === 'en'">Hungary</option>
            </select>
          </div>
          <span v-if="country === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_country_valid }}</span>
        </div>

        <div class="s-form-item">
          <label for="phone" class="s-form-item__label">{{ translations.slang_address_phone }}</label>
          <input type="text" :value="phone" class="s-form-item__field" name="phone" @input="updateValue" maxlength="20"/>
          <span v-if="phone === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_phone_valid }}</span>
        </div>

        <div class="s-form-item">
          <label for="ust" class="s-form-item__label">{{ translations.slang_address_vat }}<span v-if="country === 'DE'">(optional)</span></label>
          <input type="text" :value="ust" class="s-form-item__field" name="ust" @input="updateValue"/>
          <span v-if="country !== 'DE' && ust === '' && formSent" class="wpcf7-not-valid-tip" >{{ translations.slang_address_vat_valid }}</span>
        </div>

      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    wpData() {
      return this.$store.getters.wpdata[wpGlobalData.language];
    },
    language(){
      return wpGlobalData.language;
    },
    translations(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_address[0];
    },
    showOffer(){
      return this.$store.state.showOffer && this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    },
    ...mapState({
      email: state => state.addressForm.email,
      name: state => state.addressForm.name,
      club: state => state.addressForm.club,
      street: state => state.addressForm.street,
      zip: state => state.addressForm.zip,
      city: state => state.addressForm.city,
      country: state => state.addressForm.country,
      ust: state => state.addressForm.ust,
      phone: state => state.addressForm.phone,
      formSent: state => state.formSent,
      emailValid: state => state.emailValid
    })
  },
  data() {
    return {
      wpGlobalData
    };
  },
  methods: {
    updateValue(e){
      if(e.target.name === 'email'){
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value)) {
          this.$store.state.emailValid = true;
        } else {
          this.$store.state.emailValid = false;
        }
      }
      this.$store.commit('updateValue', { key: e.target.name, value: e.target.value })
      this.checkFormComplete();
    },
    checkFormComplete(){
      for(let value in this.$store.state.addressForm){
        if(value === 'ust'){
          if(this.$store.state.addressForm['country'] !== 'DE' && this.$store.state.addressForm[value] === ''){
            this.$store.state.addressComplete = false;
            break;
          }
        }else if(this.$store.state.addressForm[value] === ''){
          this.$store.state.addressComplete = false;
          break;
        }
        if(this.$store.state.emailValid === true){
          this.$store.state.addressComplete = true;
        }else{
          this.$store.state.addressComplete = false;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StepAddress.vue